import { renderMarkdown } from './markdown';
import { BODYUP } from './media';

/**
 * Ouvre un aperçu imprimable (PDF via l'impression navigateur) d'un contenu Pro/Plan
 * alimentaire — factorisé pour être utilisé aussi bien sur la page publique du
 * calculateur que depuis la consultation in-app (/mon-espace).
 */
export const printPlan = (title, markdownContent, isMeal) => {
  const w = window.open('', '_blank');
  if (!w) return;
  const htmlContent = renderMarkdown(markdownContent, { mealImages: isMeal });
  const today = new Date().toLocaleDateString('fr-CH');
  w.document.write(`<!DOCTYPE html><html lang="fr"><head><title>${title} — Body-Up Nyon</title>
    <meta charset="utf-8"/>
    <link rel="stylesheet" href="/fonts.css"/>
    <style>
      *{box-sizing:border-box;}
      body{font-family:'Manrope',Arial,sans-serif;color:#1a1a1a;margin:0;line-height:1.65;background:#fff;}
      .wrap{max-width:820px;margin:0 auto;padding:0 28px 48px;}
      .cover{background:linear-gradient(135deg,#B92074 0%,#E91E63 55%,#FBBF24 130%);color:#fff;padding:36px 28px;border-radius:0 0 26px 26px;margin-bottom:28px;}
      .cover-top{display:flex;align-items:center;justify-content:space-between;gap:16px;flex-wrap:wrap;}
      .cover img{height:54px;width:auto;}
      .coords{font-size:12px;line-height:1.5;text-align:right;opacity:.95;}
      .coords a{color:#fff;text-decoration:none;}
      .overline{font-family:'Outfit';font-size:11px;letter-spacing:3px;text-transform:uppercase;opacity:.9;margin-top:22px;}
      .cover h1{font-family:'Outfit';font-weight:900;font-size:30px;margin:6px 0 0;line-height:1.1;}
      .cover .sub{font-size:13px;opacity:.92;margin-top:8px;}
      h2{font-family:'Outfit';color:#B92074;font-size:20px;margin:30px 0 6px;border-left:5px solid #FBBF24;padding-left:12px;}
      h3{font-family:'Outfit';color:#111;font-size:16px;margin:18px 0 4px;}
      h4{font-family:'Outfit';color:#E91E63;font-size:14px;margin:14px 0 2px;}
      p{margin:7px 0;}
      ul,ol{margin:7px 0 7px 22px;}
      li{margin:3px 0;}
      strong{color:#111;}
      .tbl-wrap{overflow:auto;}
      table{border-collapse:collapse;width:100%;margin:12px 0;font-size:13px;}
      th,td{border:1px solid #e5d4dc;padding:7px 9px;text-align:left;}
      th{background:#fce4ec;color:#B92074;font-family:'Outfit';}
      tr:nth-child(even) td{background:#fbf6f8;}
      .meal-head{display:flex;align-items:center;gap:12px;margin:18px 0 6px;padding:8px;border-radius:12px;background:#fbf6f8;border:1px solid #f0dde6;page-break-inside:avoid;}
      .meal-head img{width:64px;height:64px;object-fit:cover;border-radius:10px;}
      .meal-head span{font-family:'Outfit';font-weight:700;color:#B92074;font-size:14px;}
      .dish-figure{margin:12px 0 16px;border-radius:14px;overflow:hidden;border:1px solid #f0dde6;page-break-inside:avoid;}
      .dish-figure img{display:block;width:100%;max-width:520px;height:auto;object-fit:cover;}
      .footer{margin-top:40px;padding-top:18px;border-top:2px solid #f0dde6;font-size:12px;color:#888;text-align:center;}
      .footer strong{color:#B92074;}
      .close-btn{position:fixed;top:14px;right:14px;z-index:999;background:#1a1a1a;color:#fff;border:none;border-radius:999px;padding:10px 18px;font-family:'Outfit',Arial,sans-serif;font-weight:700;font-size:13px;box-shadow:0 4px 16px rgba(0,0,0,.35);cursor:pointer;}
      @media print{ .meal-head img{print-color-adjust:exact;-webkit-print-color-adjust:exact;} .dish-figure img{print-color-adjust:exact;-webkit-print-color-adjust:exact;} .cover{print-color-adjust:exact;-webkit-print-color-adjust:exact;} body{print-color-adjust:exact;-webkit-print-color-adjust:exact;} .close-btn{display:none;} }
    </style></head><body>
    <button class="close-btn" onclick="window.close()">✕ Fermer</button>
    <div class="cover">
      <div class="cover-top">
        <img src="${BODYUP.logo}" alt="Body-Up"/>
        <div class="coords">
          <div><strong>${BODYUP.name}</strong></div>
          <div>${BODYUP.address}</div>
          <div>${BODYUP.phone} · ${BODYUP.email}</div>
          <div>${BODYUP.website}</div>
        </div>
      </div>
      <div class="overline">${title}</div>
      <h1>${title}</h1>
      <div class="sub">Document personnalisé · ${today}</div>
    </div>
    <div class="wrap">
      ${htmlContent}
      <div class="footer">
        <p><strong>${BODYUP.name}</strong> — ${BODYUP.address}<br/>
        ${BODYUP.phone} · ${BODYUP.email} · ${BODYUP.website}</p>
        <p>Calculs basés sur la formule Mifflin-St Jeor (précision ±10%). Document généré le ${today}.</p>
      </div>
    </div>
    </body></html>`);
  w.document.close();
  setTimeout(() => { w.focus(); w.print(); }, 700);
};
